import { useEffect } from 'react';

/** What the tab reads between pages that name themselves. */
const APP_TITLE = 'Dō';

/**
 * useDocumentTitle — names the browser tab while a page is mounted, and hands
 * it back to plain "Dō" when the page goes.
 *
 * Pass the whole title, suffix included ("Verify your email — Dō"); the hook
 * doesn't add one. A title that changes with the page's state is re-applied
 * as it changes. Public pages use `PageSEO` instead, which sets the title
 * along with the rest of the page's head tags.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(
    () => () => {
      document.title = APP_TITLE;
    },
    []
  );
}

export default useDocumentTitle;
